module.exports = __webpack_public_path__ + "static/img/icon-pay-unusual.619d123d.png";